<template><div class="color-picker">
  <ul v-for="(grp,i) in palette"
      :key="`g${i}`">
    <li v-for="(c,i) in grp"
        :key="`c${i}`"
        :style="{background:c}"
        :class="{active:c==value}"
        @click="$emit('input', c)"
      />
  </ul>
</div></template>
<script>
function getDefaultPalette() {
  let p = [], grp, 
    ch = ['0','8','f']
  for (let r=2; r>=0; r--) {
    for (let g=2; g>=0; g--) {
      grp = []
      for (let b=2; b>=0; b--) {
        grp.push(`#${ch[r]}${ch[r]}${ch[g]}${ch[g]}${ch[b]}${ch[b]}`)
      }
      p.push(grp)
    }
  }
  return p
}
export default {
  name: 'color-picker',
  props: {
    value: { default: '#00ff00' },
    palette: { default: getDefaultPalette },
  },
}
</script>
<style lang="scss" scoped>
.color-picker {
  margin: 0 5px 5px 0;
  border: 1px solid #000;
  padding: 5px 0 0 5px;
  line-height: 0;
  background: #fff;
  display: inline-flex;
  box-shadow: 5px 5px 5px rgba(0,0,0,.7);

  ul {
    display: flex;
    flex-direction: column;
    margin: 0;
    padding: 0;
    li {
      display: inline-block;
      border: 1px solid #aaa;
      width: 20px;
      height: 20px;
      margin: 0 5px 5px 0;
      &.active {
        outline: 5px solid #aaa;
      }
    }
  }

}
</style>
